<template> 
	<div class="content">
		<div class="tableTit">
			<p class="tabtitBg"></p>
			<h6>巡检线路</h6>
			<el-button class="titBtn" type="primary" icon="el-icon-plus" @click="addClick()">添加线路</el-button>
			<el-button class="titBtn" type="success" @click="reset" icon="el-icon-refresh">重置</el-button>
			<el-button class="titBtn" type="success" icon="el-icon-search">搜索</el-button>
			<el-input class="querys" v-model.trim="dw" placeholder="名称"></el-input>

			<addressTree @obj="objdata"></addressTree>

		</div>
		<div class="tabBody">
			<el-table :data="tabledata" :height="tableHeight" border :header-cell-style="{background:'rgba(49,130,222,0.1)'}">
				<el-table-column type="index" align='center' width="60" label="序号"></el-table-column>
				<el-table-column prop="username" align='center' label="状态"></el-table-column>
				<el-table-column prop="createDate" align='center' label="计划名称"></el-table-column>
				<el-table-column prop="option" align='center' label="巡检类型"></el-table-column>
				<el-table-column prop="params" align='center' label="巡检线路"></el-table-column>
				<el-table-column prop="method" align='center' label="巡检方式"></el-table-column>
				<el-table-column prop="ipAddr" align='center' label="巡检日期"></el-table-column>
				<el-table-column prop="" label="操作" width="110" align="center">
					<template slot-scope="scope">
						<el-button type="primary" icon="el-icon-view" circle @click="See(scope.$index,scope.row)" class="btnmargin"></el-button>
						<el-button type="success" class="tableedit" icon="el-icon-edit" circle @click="edit(scope.row,scope.$index)"></el-button>
						<el-button type="warning" class="tableedit" icon="el-icon-delete" circle @click="deletes(scope.row,scope.$index)"></el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fye">
			<pagintion @dsydata='DsyData' @dstdata="DstData" :ToTal='total' :pageNums="pageNums"></pagintion>
		</div>
	</div>
</template>
<script>
	import addressTree from '@/components/mangement/addressTree.vue';
	import pagintion from '@/components/mangement/pagintion.vue'
	
	export default{
		data(){
			return{
				dw:'',
				tabledata: [{}, {}, {}, ],
				tableHeight: window.innerHeight - 180,
				total: 0,
				pageSize: 10, //每页多少条数据分页
				pageNum: 0, //当前页
				pageNums: null,
				username: '',
				dw: '',
				dialogVisible: false,
				Addsid: [],
				row: null,
			}
		},
		components: {
			addressTree,
			pagintion
		},
		mounted() {
			
		},
		methods:{
			addClick(){
				
			},
			
			edit(){
				
			},
			deletes(){
				
			},
			reset(){
				
			},
			objdata(){
				
			},
			DsyData(data) { //多少页
				this.pageNum = data.dsy;
				let params = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,

				}
			},
			DstData(data) { //多少条
				this.pageSize = data.dst;
				let params = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,

				}

			},
		}
	}
	
</script>

<style scoped>
	@import url('../../../common/css/mangementall.css');
	.querys {
		height: 30px;
		float: right;
		width: 200px;
		margin-top: 10px;
		margin-right: 10px;
	}
	
	>>>.el-input__inner {
		height: 30px;
		line-height: 30px;
		color: #606266;

		font-size: 14px;
	}
</style>